import {
  Columns,
  Column,
  Text,
  Strong,
  Box,
  ContentBlock,
  Stack,
} from 'braid-design-system';
import React from 'react';

import * as styles from './Testimonial.css';

const Testimonial = () => (
  <Box padding="xlarge" className={styles.root}>
    <ContentBlock>
      <Columns space="small" collapseBelow="desktop">
        <Column width="1/4">
          <Box className={styles.img} />
        </Column>
        <Column width="3/4">
          <Box paddingY="large">
            <Stack space="gutter">
              <Text size="large">
                “With a cost market saving of at least 50% plus the team at Seek
                creating the advertisement, we will continue along this path
                into the future.”
              </Text>
              <Stack space="small">
                <Text size="large">
                  <Strong>James Clark</Strong>
                </Text>
                <Text>Manager, The Clark Brothers RayWhite Nundah</Text>
              </Stack>
            </Stack>
          </Box>
        </Column>
      </Columns>
    </ContentBlock>
  </Box>
);
export default Testimonial;
